// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QUICKTRADE_PILLS (Option A): strip 2 pill + mắt icon-only.
   Dead selectors của bản cũ (.dragZone/.dragGrip/.spreadChip/.stepper/.stepBtn/.qtyInput/.hint)
   đã xoá cùng rewrite — không consumer nào ngoài file này. */
.vvnDRqGfwhRdk3YQqceQ {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 8px;
  font-family: var(--vnsc-font-family-base, Helvetica Neue, sans-serif);
  font-size: 11px;
  color: var(--vnsc-text-primary, #e0e0e0);
  max-width: max-content;
}

.MVsNbLMccwWzEYglJRzz,
.fJ0PV6PMP3mx4R3dimcw {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  min-width: 0;
  /* Chiều cao ngang bằng các nút còn lại (» / mắt): 22px, chữ căn giữa dọc.
     Không giật khi giá nhảy (tabular-nums). */
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.MVsNbLMccwWzEYglJRzz {
  background: #dc2626;
}

.fJ0PV6PMP3mx4R3dimcw {
  background: #16a34a;
}

.MVsNbLMccwWzEYglJRzz:disabled,
.fJ0PV6PMP3mx4R3dimcw:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.jfPCoKDx1uL1H0G2mnuo {
  font-size: 10px;
  font-weight: 400;
  opacity: 0.92;
  font-variant-numeric: tabular-nums;
}

/* UIUX S4: collapsed single chip. */
.WFqxdATS53pWCPyI36kA {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
  padding: 2px 8px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  background: var(--vnsc-bg-secondary, #111820);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.c6YYLEKRZ9Wl_UYcBql5 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: transparent;
  color: var(--vnsc-text-primary, #e0e0e0);
  cursor: pointer;
  padding: 2px 6px;
  font-size: 11px;
}

.c6YYLEKRZ9Wl_UYcBql5[aria-pressed="true"] {
  background: var(--vnsc-accent, #2962ff);
  color: #fff;
}

/* A1: mắt icon-only gọn (affordance duy nhất còn lại ngoài 2 pill). */
.tKSOZ44eDDEPJ_RXtzHV {
  padding: 2px 4px;
  font-size: 12px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/widget/trading/chart/QuickTradingHeader.module.css"],"names":[],"mappings":"AAAA;;6DAE6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,qEAAqE;EACrE,eAAe;EACf,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ;8CAC4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* QUICKTRADE_PILLS (Option A): strip 2 pill + mắt icon-only.\r\n   Dead selectors của bản cũ (.dragZone/.dragGrip/.spreadChip/.stepper/.stepBtn/.qtyInput/.hint)\r\n   đã xoá cùng rewrite — không consumer nào ngoài file này. */\r\n.header {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding: 2px 6px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 8px;\r\n  font-family: var(--vnsc-font-family-base, Helvetica Neue, sans-serif);\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  max-width: max-content;\r\n}\r\n\r\n.sellBtn,\r\n.buyBtn {\r\n  display: inline-flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-width: 0;\r\n  /* Chiều cao ngang bằng các nút còn lại (» / mắt): 22px, chữ căn giữa dọc.\r\n     Không giật khi giá nhảy (tabular-nums). */\r\n  min-height: 22px;\r\n  padding: 2px 8px;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sellBtn {\r\n  background: #dc2626;\r\n}\r\n\r\n.buyBtn {\r\n  background: #16a34a;\r\n}\r\n\r\n.sellBtn:disabled,\r\n.buyBtn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.price {\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  opacity: 0.92;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* UIUX S4: collapsed single chip. */\r\n.expandBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-height: 28px;\r\n  padding: 2px 8px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 22px;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: transparent;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  font-size: 11px;\r\n}\r\n\r\n.toggle[aria-pressed=\"true\"] {\r\n  background: var(--vnsc-accent, #2962ff);\r\n  color: #fff;\r\n}\r\n\r\n/* A1: mắt icon-only gọn (affordance duy nhất còn lại ngoài 2 pill). */\r\n.eye {\r\n  padding: 2px 4px;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `vvnDRqGfwhRdk3YQqceQ`,
	"sellBtn": `MVsNbLMccwWzEYglJRzz`,
	"buyBtn": `fJ0PV6PMP3mx4R3dimcw`,
	"price": `jfPCoKDx1uL1H0G2mnuo`,
	"expandBtn": `WFqxdATS53pWCPyI36kA`,
	"toggle": `c6YYLEKRZ9Wl_UYcBql5`,
	"eye": `tKSOZ44eDDEPJ_RXtzHV`
};
export default ___CSS_LOADER_EXPORT___;
